import axios from 'axios'
import configApp from './config'

const client = axios.create({
  baseURL: `${configApp.apiURL}`,
  timeout: 15000,
})

export default client
